import BreadCrumbs from 'components/breadcrumbs'
import PMBPagination from 'components/PMBPagination'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Card, CardBody, Spinner } from 'reactstrap'
import { formatDatePMBV2 } from 'utils/formatDate'
import ICPembelian from 'assets/icons/Pembelian.png'
import { setDataInbox, toggleModalInbox } from '../dashboard/dashboardSlice'
import { useFetchInboxQuery, useFetchNotifQuery } from './notifInboxApiSlice'
import { useLazyFetchReadInboxQuery, useFetchReadNotifMutation, useFetchReadAllNotifMutation } from '../dashboard/dashboardApiSlice'
import { setFetchOption, setType } from './notifInboxSlice'
import { handleNotificationClick } from 'utils/notificationHelper'
import { Bell } from 'react-feather'
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < breakpoint)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [breakpoint])
  return isMobile
}

const NotifInboxTable = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const { tag, type } = useSelector((s) => s.notifInbox)
  const { ownerData } = useSelector((s) => s.dashboard)
  const ownerUserId = ownerData?.userId
  const [triggerReadInbox] = useLazyFetchReadInboxQuery()
  const [triggerReadNotif] = useFetchReadNotifMutation()
  const [triggerReadAllNotif] = useFetchReadAllNotifMutation()

  const resInbox = useFetchInboxQuery(
    { ...tag, type: type },
    { skip: type === 'notif' || !type },
  )

  const resNotif = useFetchNotifQuery(
    { page: tag?.page, size: tag?.size },
    { skip: type !== 'notif' || !type },
  )

  const handleRead = (id) => {
    if (type === 'notif') {
      triggerReadNotif(id).then(() => {
        if (resNotif && !resNotif.isUninitialized && typeof resNotif.refetch === 'function') {
          resNotif.refetch()
        }
      })
    } else {
      triggerReadInbox(id).then(() => {
        if (resInbox && !resInbox.isUninitialized && typeof resInbox.refetch === 'function') {
          resInbox.refetch()
        }
      })
    }
  }

  const tabs = [
    { key: 'notif', label: 'Aktivitas' },
    { key: 'general', label: 'Pemberitahuan' },
    { key: 'consent', label: 'Persetujuan' },
  ]

  const handleTabChange = (tabKey) => {
    dispatch(setType(tabKey))
  }

  const customMobileCard = (row, index) => {
    const isUnread = !row?.userinboxread && !row?.readAt
    return (
      <div
        key={index}
        className={`d-flex flex-column gap-2 px-3 py-3 ${isUnread ? 'bg-light' : 'bg-white'}`}
        style={{
          borderBottom: '1px solid #f8f9fa',
          cursor: 'pointer',
          transition: 'background-color 0.2s ease'
        }}
        data-testid={`inbox-item-${row.id}`}
        onMouseOver={(evt) => evt.currentTarget.style.backgroundColor = '#f8f9fa'}
        onMouseOut={(evt) => evt.currentTarget.style.backgroundColor = isUnread ? '#f8f9fa' : 'transparent'}
        onClick={() => {
          if (isUnread) {
            handleRead(row.id);
          }
          const navigated = handleNotificationClick(
            row,
            navigate,
            ownerUserId,
            dispatch,
            null,
          )
          if (!navigated) {
            dispatch(toggleModalInbox())
            dispatch(setDataInbox(row))
          }
        }}
      >
        <div className="d-flex align-items-center gap-2">
          <img
            style={{ width: '22px', height: '22px', objectFit: 'contain' }}
            alt="foto"
            src={row.image ? row.image : ICPembelian}
          />
          <span className="text-secondary" style={{ fontSize: '12px' }}>
            {formatDatePMBV2(row?.createdAt ?? row?.scheduledTime)}
          </span>
        </div>

        <div className="px-1 mt-1">
          <div className={`fw-bold mb-1 ${isUnread ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '14px' }}>
            {row?.title}
            {isUnread && (
              <span className="ms-2 rounded-circle bg-danger d-inline-block" style={{ width: '8px', height: '8px' }}></span>
            )}
          </div>
          <div
            className="text-muted d-block"
            style={{ fontSize: '13px' }}
          >
            {row?.message}
          </div>
        </div>
      </div>
    )
  }

  const columns = [
    {
      name: <span>Tanggal</span>,
      cell: (row) => (
        <span>{formatDatePMBV2(row?.createdAt ?? row?.scheduledTime)}</span>
      ),
      grow: 2,
    },
    {
      name: <span>Judul</span>,
      cell: (row) => {
        const isUnread = !row?.userinboxread && !row?.readAt
        return (
          <span className={isUnread ? 'fw-bold text-primary' : ''}>
            {row?.title}
            {isUnread && (
              <span className="ms-2 rounded-circle bg-danger d-inline-block" style={{ width: '8px', height: '8px' }}></span>
            )}
          </span>
        )
      },
      grow: 3,
    },
    {
      name: <span>Pesan</span>,
      cell: (row) => <span>{row?.message}</span>,
      grow: 5,
    },
    {
      name: <span></span>,
      cell: (row) => {
        const isUnread = !row?.userinboxread && !row?.readAt
        return (
          <span
            onClick={() => {
              if (isUnread) {
                handleRead(row.id);
              }
              const navigated = handleNotificationClick(
                row,
                navigate,
                ownerUserId,
                dispatch,
                null,
              )
              if (!navigated) {
                dispatch(toggleModalInbox())
                dispatch(setDataInbox(row))
              }
            }}
            className="pointer fw-semibold"
            data-testid={`inbox-item-open-${row.id}`}
          >
            Lihat Detail
          </span>
        )
      },
      grow: 2,
    },
  ]

  useEffect(() => {
    dispatch(setFetchOption({ page: 0, size: 10 }))
  }, [type])

  return (
    <>
      <div className={`w-100 ${isMobile ? 'px-0' : 'px-3'}`}>
        {!isMobile && (
          <div className="d-flex align-items-start gap-2 pt-3">
            <BreadCrumbs breadCrumbActive={'Notifikasi'} />
          </div>
        )}
        <div className={`d-flex flex-column gap-2 mb-2 ${isMobile ? 'pt-3' : ''}`}>
          <Card className={`border-0 ${isMobile ? 'shadow-none bg-transparent' : 'shadow-sm'}`}>
            <CardBody className={isMobile ? 'p-0' : ''}>
              <div className={`d-flex justify-content-between align-items-center ${isMobile ? 'px-3 mb-3' : 'mb-2'}`}>
                <h4 className="fw-bold m-0 text-dark">Notifikasi</h4>
                <div
                  className="text-primary pointer"
                  style={{ fontSize: '0.9rem', cursor: 'pointer' }}
                  onClick={() => {
                    triggerReadAllNotif().then(() => {
                      if (type === 'notif' && resNotif && !resNotif.isUninitialized && typeof resNotif.refetch === 'function') {
                        resNotif.refetch();
                      } else if (type !== 'notif' && resInbox && !resInbox.isUninitialized && typeof resInbox.refetch === 'function') {
                        resInbox.refetch();
                      }
                    })
                  }}
                >
                  Tandai Semua Dibaca
                </div>
              </div>
              <div className={`mb-1 d-flex ${isMobile ? 'px-3' : 'mt-3'}`}>
                <PMBTabSwitcher
                  activeTab={type}
                  tabs={tabs}
                  onTabChange={handleTabChange}
                  testId="inbox-tab"
                />
              </div>
              <div className="d-flex flex-column gap-0 mt-2 pb-2">
                {(type === 'notif' ? resNotif : resInbox)?.isFetching ? (
                  <div className="d-flex justify-content-center p-4">
                    <Spinner />
                  </div>
                ) : (type === 'notif' ? (resNotif?.data?.items || []) : (resInbox?.data?.items || [])).length > 0 ? (
                  (type === 'notif' ? (resNotif?.data?.items || []) : (resInbox?.data?.items || [])).map((row, index) => customMobileCard(row, index))
                ) : (
                  <div className="d-flex justify-content-center p-4 text-muted">
                    <small>Tidak ada notifikasi</small>
                  </div>
                )}
              </div>
              {((type === 'notif' ? (resNotif?.data?.totalItems || 0) : (resInbox?.data?.totalItems || 0)) > 0) && (
                <div className={`mt-3 mb-3 ${isMobile ? 'px-3' : ''}`}>
                  <PMBPagination
                    rowCount={
                      type === 'notif'
                        ? (resNotif?.data?.totalItems ?? 0)
                        : (resInbox?.data?.totalItems ?? 0)
                    }
                    currentPage={tag?.page}
                    rowsPerPage={tag?.size}
                    setCurrentPage={(e) => {
                      dispatch(setFetchOption({ page: e }))
                    }}
                    setRowsPerPage={(e) => {
                      dispatch(setFetchOption({ size: e }))
                    }}
                    testId="inbox-pagination"
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  )
}

export default NotifInboxTable
